import { cn } from '@/lib/cn'

export interface AvatarProps {
  alt?: string
  className?: string
  name: string
  src?: string | null
}

function getInitial(name: string) {
  const trimmed = name.trim()

  return trimmed ? Array.from(trimmed)[0]?.toUpperCase() : '?'
}

export function Avatar({ alt = '', className, name, src }: AvatarProps) {
  if (src) {
    return (
      <img
        alt={alt}
        className={cn('size-6 shrink-0 rounded-full object-cover', className)}
        src={src}
      />
    )
  }

  return (
    <span
      aria-hidden={alt ? undefined : true}
      className={cn(
        'inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] text-xs font-medium leading-none text-white',
        className,
      )}
      title={alt || undefined}
    >
      {getInitial(name)}
    </span>
  )
}
